import { SerializedStyles } from '@emotion/react'
import { useMemo } from 'react'
import { InputProps } from './types'

export interface useStateStylesReturn {
  validatedStyles: SerializedStyles[]
  errorStyles: SerializedStyles[]
  disabledStyles: SerializedStyles[]
  dataEnteredStyles: SerializedStyles[]
}

export interface useStateStylesProps
  extends Pick<
    InputProps,
    'validated' | 'error' | 'disabled' | 'styles' | 'value'
  > {
  overrides?: InputProps['styles']
}

export interface IUseStateStyles {
  (props: useStateStylesProps): useStateStylesReturn
}

export const useStateStyles: IUseStateStyles = ({
  validated,
  error,
  disabled,
  styles,
  value,
  overrides,
}) => {
  const validatedStyles = useMemo(() => {
    if (validated) return [styles.validated, overrides?.validated]

    return []
  }, [validated, styles.validated, overrides?.validated])

  const errorStyles = useMemo(() => {
    if (error) return [styles.error, overrides?.error]

    return []
  }, [error, styles.error, overrides?.error])

  const disabledStyles = useMemo(() => {
    if (disabled) return [styles.disabled, overrides?.disabled]

    return []
  }, [disabled, styles.disabled, overrides?.disabled])

  const dataEnteredStyles = useMemo(() => {
    if (value) return [styles.data_entered, overrides?.data_entered]

    return []
  }, [value, styles.data_entered, overrides?.data_entered])

  return {
    validatedStyles,
    errorStyles,
    disabledStyles,
    dataEnteredStyles,
  }
}
